import { forwardRef } from "react";

import { FormikEditor } from "neetoeditor";
import { useTranslation } from "react-i18next";

import { EDITOR_ADDONS } from "./constants";

const EmailBody = forwardRef(({ id, showVideoEmbedInEditor }, ref) => {
  const { t } = useTranslation();

  return (
    <FormikEditor
      {...{ id, ref }}
      required
      className="mb-6"
      data-testid="email-body"
      label={t("neetoMolecules.shareViaEmail.emailBody")}
      name="emailBody"
      addons={
        showVideoEmbedInEditor
          ? [...EDITOR_ADDONS, "video-embed"]
          : EDITOR_ADDONS
      }
    />
  );
});

EmailBody.displayName = "EmailBody";

export default EmailBody;
